import { render, staticRenderFns } from "./AccountSettingCompanyInfo.vue?vue&type=template&id=166a048a&"
import script from "./AccountSettingCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./AccountSettingCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingCompanyInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports